import { get } from 'lodash';

import { Column } from '../../modules/table';
import { DocumentsResponse } from '../../services/api/dto/Documents';
import { SORT_DIRECTION } from '../../types';
import { getFormatDate } from '../../utils/utils';

export type Columns = Column<DocumentsResponse>[];

const COLUMNS = (
  onChangeSorting: (direction: SORT_DIRECTION) => void,
  direction: SORT_DIRECTION
): Columns => [
    {
      title: 'Контрагент',
      name: 'agent',
      headerStyle: {
        width: '30%',
      },
      dataGetter: (data: DocumentsResponse) => get(data, 'agent', '-'),
    },
    {
      title: 'Документ',
      name: 'document',
      headerStyle: {
        width: '50%',
      },
      dataGetter: (data: DocumentsResponse) => get(data, 'filename', '-'),
    },
    {
      title: 'Дата и время',
      name: 'createdDate',
      headerStyle: {
        width: '20%',
      },
      isSortable: true,
      direction,
      onChangeSorting: onChangeSorting,
      dataGetter: (data: DocumentsResponse) =>
        getFormatDate(get(data, 'createdDate', new Date())),
    },
  ];

export default COLUMNS;
